import { IntegrationSelectCampaign } from '@aibees/elephant/components/integration-select-campaign';
import { ACCORDION_IDS } from '@aibees/shared/store';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { useIntegrationContext } from '../../context/integration-context';
import * as Styled from './styles';
import * as SX from './sx';
import type { ExportSelectCampaignProps as Props } from './types';

export const ExportSelectCampaign = memo(
  ({ className, expandedAccordion, setExpandedAccordion }: Props) => {
    const { selectedCampaign } = useIntegrationContext();

    return (
      <Styled.Wrapper
        className={classnames('ExportSelectCampaign', className)}
        sx={SX.root}
        id={ACCORDION_IDS.EXPORT_SELECT_CAMPAIGN}
        title="Select Campaign"
        leftIcon="campaign-outline"
        description={selectedCampaign?.name ?? 'No campaign Selected'}
        hasTag={!!selectedCampaign?.name}
        expandedAccordion={expandedAccordion}
        setExpandedAccordion={setExpandedAccordion}
      >
        <IntegrationSelectCampaign />
      </Styled.Wrapper>
    );
  }
);

ExportSelectCampaign.displayName = 'ExportSelectCampaign';
